// 导入----------------------------------------
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import XEUtils from 'xe-utils'
import './plugins/utils'
import './plugins/table'
import './axios'
import './plugins/element/index'
import './assets/css/element-ui.css'
import './assets/css/vxe-table.less'
// import './assets/css/global.less'
// 引入图标库
import './assets/icon/iconfont.css'
import './public'
import './components'
import md5 from './public/utils/md5'
// XLSX 用于excel导入
import XLSX from 'xlsx'

// 设备检测
import device from 'vue-device-detector'

// 预览图片
import hevueImgPreview from 'hevue-img-preview'

Vue.use(hevueImgPreview)

Vue.use(device)

// 挂载属性------------------------------------
Vue.prototype.$md5 = md5
Vue.prototype.$utils = XEUtils
Vue.prototype.XLSX = XLSX

Vue.config.productionTip = false

// 禁用前进后退
window.addEventListener('popstate', function () {
  history.pushState(null, null, document.URL)
})

new Vue({
  router,
  store,
  // 安装事件总线
  beforeCreate() {
    Vue.prototype.$bus = this
  },
  render: h => h(App)
}).$mount('#app')
